import { ErrorContent } from '../../components/layouts'

export default function RoutingError() {
  return <ErrorContent
    title='Page Not Found'
    subtitle='ページが見つかりませんでした'
    message='前の画面に戻ってやり直すか、システム管理者に連絡してください。'
    returnToBefore={true} />
}
